import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-29ae1e88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "da-container-fluid d-flex flex-column" }
const _hoisted_2 = { class: "slideshow-container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"bank-carousel-featured-rates-title\" data-v-29ae1e88><div class=\"bank-carousel-featured-rates-title-badge\" data-v-29ae1e88><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" data-v-29ae1e88><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.25753 9.80048C8.25753 7.7531 9.91725 6.09338 11.9646 6.09338C14.012 6.09338 15.6717 7.7531 15.6717 9.80048C15.6717 11.8479 14.012 13.5076 11.9646 13.5076C9.91725 13.5076 8.25753 11.8479 8.25753 9.80048ZM11.9646 7.59338C10.7457 7.59338 9.75753 8.58153 9.75753 9.80048C9.75753 11.0194 10.7457 12.0076 11.9646 12.0076C13.1836 12.0076 14.1717 11.0194 14.1717 9.80048C14.1717 8.58153 13.1836 7.59338 11.9646 7.59338Z\" fill=\"white\" data-v-29ae1e88></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.0546 2.3507C11.5701 1.88031 12.3591 1.88031 12.8746 2.3507L14.0397 3.41389L15.6072 3.23858C16.3007 3.16102 16.9391 3.62479 17.0796 4.30833L17.3973 5.8533L18.7685 6.63283C19.3751 6.97772 19.6189 7.72812 19.3309 8.36373L18.6797 9.80035L19.3309 11.237C19.6189 11.8726 19.3751 12.623 18.7685 12.9679L17.3973 13.7474L17.0796 15.2924C16.9711 15.8202 16.5658 16.2169 16.0674 16.3346V20.3298C16.0674 21.4445 14.7674 22.0534 13.9111 21.3398L11.9645 19.7177L10.0179 21.3398C9.1616 22.0534 7.86155 21.4445 7.86155 20.3298V16.3346C7.36333 16.2168 6.95814 15.8201 6.84964 15.2924L6.53199 13.7474L5.1608 12.9679C4.55414 12.623 4.31032 11.8726 4.5984 11.237L5.24952 9.80035L4.5984 8.36373C4.31032 7.72813 4.55414 6.97772 5.1608 6.63283L6.53199 5.8533L6.84964 4.30834C6.99018 3.62479 7.62852 3.16102 8.32203 3.23858L9.88955 3.41389L11.0546 2.3507ZM9.36155 16.2459V19.9342L11.1228 18.4665C11.6104 18.0602 12.3186 18.0602 12.8061 18.4665L14.5674 19.9342V16.2458L14.0397 16.1868L12.8746 17.25C12.3591 17.7204 11.5701 17.7204 11.0546 17.25L9.88955 16.1868L9.36155 16.2459ZM11.9646 3.55098L10.8504 4.56773C10.5632 4.82985 10.1768 4.95538 9.79039 4.91216L8.29134 4.7445L7.98756 6.22198C7.90925 6.60289 7.67048 6.93152 7.33242 7.12371L6.02113 7.86919L6.64381 9.24305C6.80434 9.59724 6.80434 10.0035 6.64381 10.3576L6.02113 11.7315L7.33242 12.477C7.67048 12.6692 7.90925 12.9978 7.98756 13.3787L8.29134 14.8562L9.79039 14.6885C10.1768 14.6453 10.5632 14.7708 10.8504 15.033L11.9646 16.0497L13.0788 15.033C13.3661 14.7708 13.7524 14.6453 14.1389 14.6885L15.6379 14.8562L15.9417 13.3787C16.02 12.9978 16.2588 12.6692 16.5968 12.477L17.9081 11.7315L17.2855 10.3576C17.1249 10.0035 17.1249 9.59724 17.2855 9.24305L17.9081 7.86918L16.5968 7.12371C16.2588 6.93152 16.02 6.60289 15.9417 6.22198L15.6379 4.7445L14.1389 4.91216C13.7524 4.95538 13.3661 4.82985 13.0788 4.56773L11.9646 3.55098Z\" fill=\"white\" data-v-29ae1e88></path></svg></div><div class=\"bank-carousel-featured-rates-title-text\" data-v-29ae1e88>TODAY&#39;S FEATURED RATES</div></div>", 1)
const _hoisted_4 = ["id"]
const _hoisted_5 = {
  key: 0,
  class: "carouselNav-container"
}
const _hoisted_6 = {
  key: 0,
  class: "navigation desktop-tablet-only"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15.6255 19.25L8.38113 12.0039C8.37722 12 8.37722 11.9937 8.38113 11.9898L15.6259 4.75",
    stroke: "#0069BA",
    "stroke-width": "3.5",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8.37443 19.2627L15.6188 12.004C15.6227 12.0001 15.6227 11.9937 15.6188 11.9898L8.37401 4.73748",
    stroke: "#0069BA",
    "stroke-width": "3.5",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "navigation mobile-only"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15.6255 19.25L8.38113 12.0039C8.37722 12 8.37722 11.9937 8.38113 11.9898L15.6259 4.75",
    stroke: "#0069BA",
    "stroke-width": "3.5",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8.37443 19.2627L15.6188 12.004C15.6227 12.0001 15.6227 11.9937 15.6188 11.9898L8.37401 4.73748",
    stroke: "#0069BA",
    "stroke-width": "3.5",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_item = _resolveComponent("item")!
  const _component_loader = _resolveComponent("loader")!

  return (_ctx.showComponent)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        id: "app",
        class: _normalizeClass({ 'desktop-hidden': !_ctx.desktopView })
      }, [
        _createElementVNode("div", {
          id: "adsCarouselWpHolder",
          style: _normalizeStyle(_ctx.inlineStyle),
          role: "region",
          "aria-label": "Ads Carousel",
          "aria-live": "polite",
          "aria-atomic": "false"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", {
                class: "carouselWbuttons",
                id: _ctx.zoneKey
              }, [
                _createElementVNode("div", {
                  class: "carousel-container",
                  ref: "carouselContainer",
                  onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
                  role: "list",
                  "aria-label": "Carousel Slides"
                }, [
                  (_ctx.isLoaded)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.placements, (placement, index) => {
                        return (_openBlock(), _createBlock(_component_item, {
                          key: placement.id + '-' + index,
                          index: index,
                          model: placement,
                          zoneKey: _ctx.zoneKey,
                          ratingsData: _ctx.localRatingsData,
                          slideCount: _ctx.placements.length,
                          cardWidth: _ctx.cardWidth
                        }, null, 8, ["index", "model", "zoneKey", "ratingsData", "slideCount", "cardWidth"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_loader, { key: 1 }))
                ], 544),
                (_ctx.isLoaded && _ctx.placements.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (_ctx.placements.length > 3)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("a", {
                              class: "prev-button prev",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.prevButtonClick && _ctx.prevButtonClick(...args))),
                              "aria-label": "Prev Slide",
                              role: "button",
                              tabindex: "0"
                            }, _hoisted_8),
                            _createElementVNode("a", {
                              class: "next-button next",
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.nextButtonClick && _ctx.nextButtonClick(...args))),
                              "aria-label": "Next Slide",
                              role: "button",
                              tabindex: "0"
                            }, _hoisted_10)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.placements.length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("a", {
                              class: "prev-button prev",
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.prevButtonClick && _ctx.prevButtonClick(...args))),
                              "aria-label": "Prev Slide",
                              role: "button",
                              tabindex: "0"
                            }, _hoisted_13),
                            _createElementVNode("a", {
                              class: "next-button next",
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.nextButtonClick && _ctx.nextButtonClick(...args))),
                              "aria-label": "Next Slide",
                              role: "button",
                              tabindex: "0"
                            }, _hoisted_15)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_4)
            ])
          ])
        ], 4)
      ], 2))
    : _createCommentVNode("", true)
}